import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ChargePointStrategyDetailsComponent from "./ChargePointStrategyDetailsComponent";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const accordionSx = {
  borderRadius: "var(--radiusLg) !important",
  boxShadow: "var(--shadowSm)",
  border: "1px solid var(--borderColor)",
  "&:before": { display: "none" },
  "&.Mui-expanded": { margin: 0 },
};
const summarySx = {
  direction: "rtl",
  minHeight: 48,
  "& .MuiAccordionSummary-content": { margin: "12px 0" },
  "& .MuiAccordionSummary-expandIconWrapper": { color: "var(--primaryColor)" },
};
const detailsSx = {
  direction: "rtl",
  padding: "0 var(--spacingLg) var(--spacingLg)",
  paddingTop: 0,
};

export const ChargePointStrategyAccordionElementComponent = ({ chargingStrategy }) => {
  return (
    <Accordion sx={accordionSx}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={summarySx}>
        <Typography sx={{ fontWeight: 600, color: "var(--textPrimary)", fontSize: "var(--fontSizeMd)" }}>
          פירוט תעריפי טעינה
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={detailsSx}>
        <ChargePointStrategyDetailsComponent chargingStrategy={chargingStrategy} />
      </AccordionDetails>
    </Accordion>
  );
};

export default ChargePointStrategyAccordionElementComponent;
